const config = {
    playerVars: {
        playsinline: 1, // 移动端禁止全屏
        enablejsapi: 1, // js api 控制 youtube
        modestbranding: 1, // YouTube 徽标
        controls: 0, // 播放器控件
        disablekb: 1,
        autoplay: 1, // 1
        rel: 0, // 相关视频
        fs: 0, // 全屏
        cc_lang_pref: 0,
        cc_load_policy: 0,
        iv_load_policy: 3,
        // origin: 'http://5g-h.nuwarobotics.com:8091'
        // html5: 1
    },
    screen: { videoId: 'Vbks4abvLEw', width: '100%', height: '100%' },
    robot: { videoId: 'Vbks4abvLEw', width: '100%', height: '100%' }
}

const cosntVar = {
    robot: null, screen: null, inited: false, robotEvent: null, screenEvent: null
}

const watchVar = {
    endMark: {
        data: 0,
        function () {   
            console.log(this)
            this.data ++
            if (this.data > 1) {
                window.sendReply$()
                this.data = 0
            }
        }
    }
}

function initYoutubeApi () {
    console.log('initYoutubeApi')
    return new Promise ((res) => {
        if ( cosntVar.inited ) return res()
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        window.onYouTubeIframeAPIReady = () => {
            cosntVar.inited = true
            console.log('initYoutubeApi inited')
            res()
        }
    })
}

function creatScreenIframe (iframeId = 'screenYoutubeIframeId') {
    if (cosntVar.screen) {
        return cosntVar.screen
    }
    const screen = document.createElement('div')
    screen.setAttribute('id', 'screenYoutubeIframeId')
    document.body.appendChild(screen)
    cosntVar.screen = new window.YT.Player(iframeId, {
        ...config.screen,
        playerVars: config.playerVars,
        events: {
            onError (event) {
                console.log('onError', event)
                event.target && event.target.stopVideo && event.target.stopVideo()
            },
            onReady (event) {
                cosntVar.screenEvent = event
                window.ytPlayCallBack$$ || event.target.stopVideo()
                console.log('onReady', event)
            },
            onStateChange (event) {
                console.log('onStateChange', event)
                event.data === 0 && watchVar.endMark.function()
            }
        }
    })
    return cosntVar.screen
}

function creatRobotIframe (iframeId = 'robotYoutubeIframeId') {
    if (cosntVar.robot) {
        return cosntVar.robot
    }
    const robot = document.createElement('div')
    robot.setAttribute('id', 'robotYoutubeIframeId')
    document.body.appendChild(robot)
    cosntVar.robot = new window.YT.Player(iframeId, {
        ...config.robot,
        playerVars: config.playerVars,
        events: {
            onError (event) {
                console.log('onError', event)
                event.target && event.target.stopVideo && event.target.stopVideo()
            },
            onReady (event) {
                // event.target.mute()
                cosntVar.robotEvent = event
                window.ytPlayCallBack$$ || event.target.stopVideo()
                console.log('onReady', event)
            },
            onStateChange (event) {
                event.data === 0 && watchVar.endMark.function()

                console.log('onStateChange', event)
            }
        }
    })
    return cosntVar.robot
}

function appendToScreen () {
    if (document.querySelector('#youtubeScreenIframeWrapperId > #screenYoutubeIframeId')) return
    const dom = document.getElementById('youtubeScreenIframeWrapperId')
    dom.appendChild(
        document.getElementById('screenYoutubeIframeId')
    )
}

function appendToRobot ($s) {
    return $s.create3dPage.bind($s)()
}

export default {
    initYoutubeApi, creatScreenIframe, creatRobotIframe, appendToScreen, appendToRobot, cosntVar
}
